module.exports = __webpack_public_path__ + "img/banner_title.0a9b77c9.png";